import { atom } from "recoil";


const usersAdminAtom = atom({
  key: 'usersAdmin',
  default: {
    payload: [],
    loading: false
  }
});

const crudUsersAdminAtom = atom({
  key: 'crudUsersAdminAtom',
  default: {
    status: 500,
    message: '',
    loading: false
  }
});


export { crudUsersAdminAtom, usersAdminAtom};